angular.module('stack.common.api.ApiService', [
  'global'
])

/**
 * The ApiService service stores methods used to access
 * system APIs.
 *
 * @class ApiService
 * @constructor
 * @module stack.common.api.ApiService
 */
.factory('ApiService', [
  '$rootScope',
  '$location',
  '$resource',
  '$http',
  'GLOBAL',
  'ErrorService',
  function ($rootScope, $location, $resource, $http, GLOBAL, ErrorService) {
    'use strict';

    var service;

    $rootScope.sessionId = null;

    service = {
      /**
       * Holds all of the api references
       * @property apis
       * @type {Object}
       */
      apis: {
        endpoints: []
      },

      /**
       * Configuration properties used by $http for API calls
       * https://docs.angularjs.org/api/ng/service/$http
       * @property config
       * @type {Object}
       */
      config: {
        timeout: 30000,
        withCredentials: false,
        isArray: false
      },

      /**
       * gets remote tokens for remote api calls
       *
       * @param {string} server - server url
       * @param {string} token - auth token
       * @type {Object}
       */
      getRemoteToken: function (server, token) {
        return $http({
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + token,
            piSession: localStorage.getItem('piSession')
            //PiSessionId: 'q'
          },
          url: GLOBAL.apiPath + '/auth/s2s?url=' + server
        }).then(function successCallback(response) {
          return response;
        }).catch();
      },

      /**
       * handles requests to remote servers
       *
       * @param {string} href - Link to API
       * @param {Object} params - server and token in the object passed
       * @return {Object} JSON response payload
       */
      remoteRequest: function (href, params) {
        return $http({
          method: 'GET',
          headers: {
            Authorization: params.token         
          },
          url: params.server + href
        }).success(function (data, status, headers) {
          var response;
          if (params.headers) {
            response = {
              data: data,
              headers: headers()
            };
          } else {
            response = data;
          }
          $rootScope.$broadcast('ApiRequestComplete');
          return response;
        })
        .error(function (data, status, headers, config) {
          console.log('api error', data, status, headers, config);
        });
      },

      /**
       * Executes the provided api using the sendData as
       * the payload
       *
       * @param {string} href - Link to API
       * @param {string} method - The method to execute the api as (GET, POST, PUT, DELETE)
       * @param {Object} sendData - JSON payload
       * @param {boolean} withHeaders - include header in the package
       * @param {integer} timeout - number of miliseconds to allow for request
       * @return {Object} JSON response payload
       */
      execute: function execute(href, method, sendData, withHeaders, timeout) {
        var apiResponse;
        var resource;
        var url = href;

        if ($location.host() === 'localhost') {
          url = url.replace(/.*\/api/, GLOBAL.apiPath);
        }

        resource = service.getResource(url, method, sendData, withHeaders, timeout);

        $rootScope.processing = true;

        apiResponse = resource.engage(sendData,
          function () {
            $rootScope.processing = false;
            $rootScope.$broadcast('ApiRequestComplete');
          },
          function (response) {
            ErrorService.requestError(response);
            service.setConfigHeaders(null);
            apiResponse.response = response;
          }
        );

        return apiResponse.$promise;
      },


      /**
       * Returns a $resource object for the API
       * https://docs.angularjs.org/api/ngResource/service/$resource
       *
       * @param {string} href - URI of an endpoint
       * @param {string} method - The method to execute the endpoint as (GET, POST, PUT, DELETE)
       * @param {Object} sendData - JSON data
       * @param {boolean} withHeaders - include header in the package
       * @param {integer} timeout - number of miliseconds to allow for request
       * @return {Object} JSON response payload
       */
      getResource: function getResource(href, method, sendData, withHeaders, timeout) {
        var config = service.getConfig(href, method, sendData, withHeaders, timeout);
        var resource = $resource(href + '/:id', { id: '@id' }, {
          engage: config
        });

        return resource;
      },

      /**
       * Returns an appropriate configuration object based on the type
       * of API call.  The main service.config object is used as a template
       *
       * @param {string} href - URI of an endpoint
       * @param {string} method - The method to execute the endpoint as (GET, POST, PUT, DELETE)
       * @param {Object} sendData - JSON data
       * @param {boolean} withHeaders - include header in the package
       * @param {integer} timeout - number of miliseconds to allow for request
       * @return {Object} Service configuration
       */
      getConfig: function getConfig(href, method, sendData, withHeaders, timeout) {
        var config;

        config = _.cloneDeep(service.config);
        config.method = method;

        // If get all then return is a list
        if (method === 'GET' && !sendData) {
          config.isArray = true;
        } else {
          config.isArray = false;
        }

        // clear params and data
        delete config.params;
        delete config.data;

        // GET and DELETE data is send via query params
        if (method === 'GET' || method === 'DELETE') {
          config.params = sendData;
        }

        // POST and PUT data is send via data payload
        if (method === 'POST' || method === 'PUT') {
          config.data = sendData;
        }

        if (withHeaders) {
          config.transformResponse = function (data, headers) {
            var response = {};
            response.data = JSON.parse(data);
            response.headers = headers();
            return response;
          };
        }

        if (timeout) {
          config.timeout = timeout;
        }

        return config;
      },

      /**
       * Allows applications to inject custom headers.
       *
       * @param {Object} headers - Configuration headers object
       */
      setConfigHeaders: function setConfigHeaders(headers) {
        service.config.headers = headers;
      }

    };

    return service;
  }
]);
